import React from 'react';
import { classNames } from '@/utils/class-names';

interface LoadingContainerProps {
  title?: string;
  className?: string;
}

export const LoadingContainer: React.FC<LoadingContainerProps> = ({ title = 'Loading...', className }) => {
  return (
    <div className={classNames('flex min-h-96 flex-col items-center justify-center p-8', className || '')}>
      <div className="mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-blue-600"></div>
      <p className="text-lg text-gray-600">{title}</p>
    </div>
  );
};
